/* eslint-disable object-shorthand,no-underscore-dangle */
export default {
    // use anonymous function instead of short hand to prevent binding the scope
    // as is in the example here (https://vuejs.org/v2/guide/custom-directive.html)
    bind: function (el, binding, vnode) {
        // eslint-disable-next-line no-param-reassign
        vnode.context.__ironsourceClickOutsideInnerFunction__ = (e) => {
            const { handler, exclude } = binding.value;
            let clickedOnExcludedEl = false;
            exclude.forEach((refName) => {
                if (!clickedOnExcludedEl) {
                    const excludedEl = vnode.context.$refs[refName];
                    const refTag = e.path.find((element) => element.id === refName);
                    if (excludedEl) {
                        clickedOnExcludedEl = excludedEl.contains(refTag);
                    }
                }
            });
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                vnode.context[handler](e.target);
            }
        };

        document.addEventListener('click', vnode.context.__ironsourceClickOutsideInnerFunction__);
        document.addEventListener('touchstart', vnode.context.__ironsourceClickOutsideInnerFunction__);
        document.addEventListener('drag', vnode.context.__ironsourceClickOutsideInnerFunction__);
    },

    unbind: function (el, binding, vnode) {
        document.removeEventListener('click', vnode.context.__ironsourceClickOutsideInnerFunction__);
        document.removeEventListener('touchstart', vnode.context.__ironsourceClickOutsideInnerFunction__);
        document.removeEventListener('drag', vnode.context.__ironsourceClickOutsideInnerFunction__);
    }
};
